import { errorThatWillCauseAlert } from "owa-trace";
import { parseNovaEventToOwaAction } from "./utils/parseNovaEventToOwaAction";
import type { NovaEvent, NovaEventing } from "@nova/types";
import type { NovaEventUnion } from "owa-nova-actions";
import { NovaLogger } from "owa-analytics-nova-logger";
import { NOVA_TELEMETRY_EVENT_TYPE } from "@1js/midgard-types";
import type { TraceErrorObject } from "owa-analytics-types";

export const novaEventing: NovaEventing = {
    bubble(event: {
        event: NovaEvent<unknown | NovaEventUnion>;
    }): Promise<void> {
        try {
            const novaEvent = event.event as NovaEventUnion;
            
            if (novaEvent.type === NOVA_TELEMETRY_EVENT_TYPE) {
                NovaLogger.logEvent(novaEvent);
                return Promise.resolve();
            }
            
            const action = parseNovaEventToOwaAction(novaEvent);
            if (action) {
                action(novaEvent);
            }
            else {
                errorThatWillCauseAlert("Failed to parse nova event to action: undefined");
            }
            return Promise.resolve();
        }
        catch (err) {
            const traceErrorObject: TraceErrorObject = new Error("NovaEventing_BubbleError");
            if (err instanceof Error) {
                traceErrorObject.stack = err.stack;
                traceErrorObject.additionalInfo = {
                    diagnosticMessage: err.message,
                    novaEvent: JSON.stringify(event),
                };
            }
            else {
                traceErrorObject.additionalInfo = {
                    diagnosticMessage: "Unknown error",
                    novaEvent: JSON.stringify(event),
                };
            }
            errorThatWillCauseAlert("NovaEventing_BubbleError", traceErrorObject);
            return Promise.resolve();
        }
    },
};
